import gql from 'graphql-tag'

export default gql`
  mutation removeUserFromSubscription($email: String!) {
    removeUserFromSubscription(email: $email) {
      success
      message
    }
  }
`
